import { lazy } from "react";
import Loadable from "components/Loadable";

const SkillList = Loadable(
  lazy(() => import("features/skill/components/List"))
);
const SkillPage = Loadable(
  lazy(() => import("features/skill/components/Page"))
);

const routes = {
  path: "skill",
  children: [
    { path: "", element: <SkillList /> },
    { path: "add", element: <SkillPage /> },
    { path: "edit/:skillID?", element: <SkillPage /> },
  ],
};

export default routes;
